import * as React from "react";
import { forwardRef } from "react";
const SvgBusinessInteligence = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M16.0096 18.4096C17.335 18.4096 18.4096 17.3351 18.4096 16.0096C18.4096 14.6841 17.335 13.6096 16.0096 13.6096C14.6841 13.6096 13.6096 14.6841 13.6096 16.0096C13.6096 17.3351 14.6841 18.4096 16.0096 18.4096Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M19.9697 19.9694C26.2181 13.721 29.5105 6.88284 27.3236 4.69591C25.1367 2.50897 18.2985 5.80143 12.0501 12.0498C5.80171 18.2982 2.50925 25.1364 4.69619 27.3233C6.88312 29.5103 13.7213 26.2178 19.9697 19.9694Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M27.3236 27.3233C29.5105 25.1364 26.2181 18.2982 19.9697 12.0498C13.7213 5.80142 6.88312 2.50897 4.69619 4.6959C2.50925 6.88284 5.80171 13.721 12.0501 19.9694C18.2985 26.2178 25.1367 29.5103 27.3236 27.3233Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgBusinessInteligence);
export default ForwardRef;
